import NetworkService from '../services/network.service'

class CompanyApi {
  getCompanies = async (migrationPlatform?: string) => {
    let config = {};
    let url = `api/companies`;
    try {
      let data: any
      if (!migrationPlatform) {
        data = await NetworkService.get(url, config);
        
      } else {
        data = await NetworkService.superGet(url,  migrationPlatform, config);
      }
      return data && data.data
      ? data.data : data
    } catch (error: any) {
      console.error(error)
    }
  }
  getSupportUserForCompany = async (companyId: any, migrationPlatform?: string) => {
    let url = 'api/companies/getSupportUser';
    let config = {
      params: {
        companyId
      }
    }
    let data: any
    if (!migrationPlatform) {
      data = await NetworkService.get(url, config);
      
    } else {
      data = await NetworkService.superGet(url,  migrationPlatform, config);
    }
    return data
  }
  auth = async (params: any, migrationPlatform?: string) => {
    let url = 'api/companies/auth';
    try {
      let data: any
      if (!migrationPlatform) {
        data = await NetworkService.post(url, params);
        
      } else {
        data = await NetworkService.superPost(url,  migrationPlatform, params);
      }
      return data && data.data
      ? data.data : data
    } catch (error: any) {
      console.error(error)
    }
  }
  getActivity = async (options: any) => {
    let url = `api/companies/activity`;
    let config = {
       params:{
        options  
      }
     };
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data
  };
  getActivityCount = async () => {
    let url = `api/companies/activitycount`;
    let config ={};
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data
  };
  getFPformList = async () => {
    let url = `api/companies/fpform/list`
    let config = {}
    try {
        let data = await NetworkService.get(url, config)
        return data
    } catch (error : any) {   
        console.error(error)
    }
}
  addFPForm = async (body: any, migrationPlatform?: string) => {
    let url = `api/companies/fpform`
    let config = body
    try {
      let data: any
      if (!migrationPlatform) {
        data = await NetworkService.post(url, config);
      } else {
        data = await NetworkService.superPost(url,  migrationPlatform, config);
      }
      return data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  getCompaniesWithFPForms = async () => {
    let url = `api/companies/fpform/company/list`
    let config = {}
    try {
        let data = await NetworkService.get(url, config)
        return data;
    } catch (error : any) {   
        console.log(error)
    }
  }
  

  updateCompanyReminderBannerDetails = async (body: any) => {
    let url = `api/companies/rrb`
    const config = body
    try {
        let data = await NetworkService.post(url, config)
        return data
    } catch (error: any) {
        throw error
    }
  }
  
  registerNewCompany = async (params: any) => {
    try {
        let url = `api/companies/register`;
        let body = {params };
        let data = await NetworkService.put(url, body)
    return data && data.data
        ? data.data : data
    }catch(err: any){
        return err.description? err.description : err;
    }
};
setLocaleSettings = async (params: any) => {
  try {
      let url = `api/companies/setLocaleSettings`;
      let body = {params };
      let data = await NetworkService.put(url, body)
  return data && data.data
      ? data.data : data
  }catch(err: any){
      return err.description? err.description : err;
  }
};
onlineWebBooking = async (setting: any = {}) => {
  let url = `api/companies/onlineBooking`;
  let data = await NetworkService.put(url, setting)
  return data && data.data
    ? data.data : data
};
insertOBStatus = async (obStatuses: any = []) => {
  let url = `api/companies/obStatus`;
  let data = await NetworkService.post(url, obStatuses)  
  return data && data.data
    ? data.data : data
};
insertOBSource = async (obSources: any = []) => {
  let url = `api/companies/obSource`;
  let data = await NetworkService.post(url, obSources)
  return data && data.data
    ? data.data : data
};
templateId = async (obStatuses: any = []) => {
  let url = `api/companies/templateId`;
  let data = await NetworkService.put(url, obStatuses)  
  return data && data.data
    ? data.data : data
};

getAllSupportedCompanies = async () => {
  let url = `api/companies/supportedCountries`;
  let data = await NetworkService.get(url,{})
  return data && data.data
    ? data.data : data
};

getStandardAssignmentStatuses = async (companyId: number) => {
  let data = await NetworkService.get(`api/companies/assignmentstatus/${companyId}`, {});
  return data && data.data ? data.data : data;
};

getCustomAssignmentStatuses = async (companyId: number) => {
  let data = await NetworkService.get(`api/companies/assignmentstatuscf/${companyId}`, {});
  return data && data.data ? data.data : data;
};

getTargetCompanyTicketSettings = async (companyId: number) => {
  let data = await NetworkService.get(`api/companies/ticketsettings/${companyId}`, {});
  return data && data.data ? data.data : data;
};

enableCustomAssignmentStatus = async (body: any) => {
  let data = await NetworkService.post(`api/companies/customassignmentstatus/enable`, body);
  return data && data.data ? data.data : data;
};

addCustomAssignmentStatuses = async (body: any) => {
  let data = await NetworkService.post(`api/companies/customassignmentstatus/add`, body);
  return data && data.data ? data.data : data;
};

updateCustomAssignmentStatuses = async (body: any) => {
  let data = await NetworkService.put(`api/companies/customassignmentstatus/update`, body);
  return data && data.data ? data.data : data;
};

disableCustomAssignmentStatus = async (body: any) => {
  let data = await NetworkService.post(`api/companies/customassignmentstatus/disable`, body);
  return data && data.data ? data.data : data;
};

createBannerAnnouncement = async (body: any) => {
  let url = `api/companies/announcement`;
  try {
    let data = await NetworkService.post(url, body);
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

deactivateBannerAnnouncement = async (body: any) => {
  let url = `api/companies/announcement`;
  try {
    let data = await NetworkService.delete(url, body);
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

getBannerAnnouncements = async () => {
  let url = `api/companies/announcements`;
  try {
    let data = await NetworkService.get(url, {});
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

createAnnouncementTemplate = async (body: any) => {
  let url = `api/companies/announcement/template`;
  try {
    let data = await NetworkService.post(url, body);
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

getAnnouncementTemplates = async (platform: string = 'crm') => {
  let url = `api/companies/announcement/templates?platform=${platform}`;
  try {
    let data = await NetworkService.get(url, {});
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

uploadAnnouncementImage = async (formData: FormData) => {
  let url = `api/companies/announcement/upload-image`;
  try {
    let data = await NetworkService.post(url, formData, { headers: { 'Content-Type': undefined } } as any);
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

deleteAnnouncementTemplate = async (templateId: string) => {
  let url = `api/companies/announcement/template/${templateId}`;
  try {
    let data = await NetworkService.delete(url, {});
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

editRecurringAnnouncement = async (announcementId: string, body: any) => {
  let url = `api/companies/announcement/recurrence/${announcementId}`;
  try {
    let data = await NetworkService.put(url, body);
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

cancelRecurringAnnouncement = async (announcementId: string, companyIds: string[], platform: string = 'crm') => {
  let url = `api/companies/announcement/recurring/${announcementId}`;
  try {
    let data = await NetworkService.delete(url, { companyIds, platform });
    return data && data.data ? data.data : data;
  } catch (error: any) {
    throw error;
  }
};

}
export default CompanyApi;